import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/login.css';
require('../../assets/css/main.css');
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function Alumni(props) {
    document.title = props.title
    const [userEmailValue, setEmailValue] = useState("");
    const [userOTPScreenValue, setOTPScreenValue] = useState(false);
    const [userOTPValue, setOTPValue] = useState("");

    const navigate = useNavigate();

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    function onSubmitVerifyOTPClick() {
        if (userOTPValue) {
            axios.post(config.API_URL + 'verifyOTPForAlumniLogin', {
                inputEmailId: userEmailValue,
                genratedOtp: userOTPValue
            }, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            }).then(function (response) {
                console.log("response.data.data --->>>>>", response.data.data);
                if (response.data.status.status == 1) {
                    toast.success(response.data.status.message);
                    localStorage.setItem("isAuthenticated", true);
                    navigate('/AlumniDashboard');
                } else {
                    toast.warning(response.data.status.message);
                }
                console.log(response.data.data);
            }).catch(function (error) {
                toast.error(error);
            });
        } else {
            toast.error("Please enter OTP.");
        }
    }

    function onSubmitResendOTPClick() {
        if (userEmailValue) {
            axios.post(config.API_URL + 'resendOTPForAlumniLogin', {
                inputEmailId: userEmailValue,
            }, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
            }).then(function (response) {
                console.log("response.data.data --->>>>>", response.data.data);
                if (response.data.status.status == 1) {
                    toast.success(response.data.status.message);
                } else {
                    toast.warning(response.data.status.message);
                }
                console.log(response.data.data);
            }).catch(function (error) {
                toast(error);
            });
        } else {
            toast.error("Please enter email address.");
        }
    }

    function onSubmitClick() {
        if (userEmailValue) {
            if (validateEmail(userEmailValue)) {
                axios.post(config.API_URL + 'checkAlumniLogin', {
                    inputEmailId: userEmailValue,
                }, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                }).then(function (response) {
                    console.log("response.data.data --->>>>>", response.data.data);
                    if (response.data.status.status == 1) {
                        console.log("response.data.data --->>>>>", response.data.data.alr_admin_uploaded_bit);
                        if (response.data.data.alr_admin_uploaded_bit == "0") {
                            var JSONObj = {
                                alr_academic_year: response.data.data.alr_academic_year,
                                alr_auto_id: response.data.data.alr_auto_id,
                                alr_email_id: response.data.data.alr_email_id
                            };
                            localStorage.setItem('userAlumniDetailsLog', JSON.stringify(JSONObj));
                             toast.success(response.data.status.message);
                            setOTPScreenValue(true);
                            userOTPValue("");
                        }
                        if (response.data.data.alr_admin_uploaded_bit == "1") {
                            var JSONObj = {
                                alr_academic_year: response.data.data.alr_academic_year,
                                alr_auto_id: response.data.data.alr_auto_id,
                                alr_email_id: response.data.data.alr_email_id
                            };
                            localStorage.setItem('userAlumniDetailsLog', JSON.stringify(JSONObj));
                            toast.success("Login Successfully....");
                            localStorage.setItem("isAuthenticated", true);
                            navigate('/AlumniDashboard');
                        }

                    } else if (response.data.status.status == 2) {
                        toast.warning(response.data.status.message);
                    } else {
                        toast.warning(response.data.status.message);
                    }
                    console.log(response.data.data);
                }).catch(function (error) {
                    toast.error(error);
                });
            } else {
                toast.warning("Please enter valid email address.");
            }
        } else {
            toast.error("Please enter email address.");
        }
    }

    const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
    return (
        <div className="login-module page-wrapper font-robo" >
            <div className="login-box">
                <div className="card card-1">
                    <div className="logo-holder">
                        <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                        <div className='feedback-title' >Alumni Feedback System</div>
                    </div>
                    <div className="card-body">
                        {userOTPScreenValue == false ?
                            <>
                                <div className='row'>
                                    <div className="form-group  col-xs-12  col-sm-12 col-md-12">
                                        <label>Enter Your Email Address:</label>
                                        <input className="form-control" placeholder='Enter Your Email Address' value={userEmailValue} onChange={(e) => setEmailValue(e.target.value)} id="inputUserValue" type="text" />
                                    </div>
                                </div>
                                <div className="p-t-20">
                                    <button className="btn btn-primary btn-block" type="button" onClick={onSubmitClick} id='btnLogin'>Verify Email</button>
                                </div>
                            </>
                            :
                            <>
                                <div className='row'>
                                    <div className="form-group  col-xs-12  col-sm-12 col-md-12">
                                        <label>OTP has been sent to {userEmailValue}</label>
                                        <input className="form-control" placeholder='Enter OTP' value={userOTPValue} onChange={(e) => setOTPValue(e.target.value)} id="inputOTPValue" type="text" />
                                    </div>
                                </div>
                                <div className="p-t-20">
                                    <button className="btn btn-primary btn-block" type="button" onClick={onSubmitVerifyOTPClick} id='btnLogin'>Verify OTP</button>
                                    <a onClick={onSubmitResendOTPClick} style={{ fontSize: '12px', color: 'red', marginTop: '15px', cursor: 'pointer', display: 'inline-block', textAlign: 'right', width: '100%', textDecoration: 'underline' }} id="OTPResent">Resend OTP?</a>
                                </div>
                            </>
                        }
                        <section className='section-footer'>
                            <div className='row'>
                            <div className='col-md-12'>
                                <div className='footer' style={{ textAlign: 'right', borderTop: 'none' }}>{config.PoweredBy}</div>
                            </div></div>
                        </section>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

